import Api from '../../common/api';

const api = Api.getApi();
const apiIRS = Api.getApiIRS();

export async function requestTokenApi({ queryString, ssoUrl }) {
  const response = await api.request('post', '/oauth2/token', queryString, {
    baseURL: ssoUrl,
  });
  return response;
}

export async function requestRefreshTokenApi({ queryString, ssoUrl }) {
  const response = await api.request('post', '/oauth2/token', queryString, {
    baseURL: ssoUrl,
    transformRequest: [
      (data, headers) => {
        delete headers.Authorization;
        headers['Content-Type'] = 'application/x-www-form-urlencoded';
        return data;
      },
    ],
  });
  return response;
}

export async function requestPasswordResetApi({ username, method, mobile_phone, type = 'code' }) {
  return apiIRS.request('post', '/identity/password-reset-request', {
    username,
    mobile_phone,
    method,
    type,
  });
}

export async function requestUpdateCustomerPasswordApi({
  guid,
  password,
  validity_days = -1,
  target = 'password',
}) {
  return apiIRS.request('put', `/users/${guid}/password`, { password, target, validity_days });
}

export async function requestUpdateUsernameApi({ guid, pending_username }) {
  return apiIRS.request('put', `/users/${guid}/pending_username`, { pending_username });
}

export async function requestGetUserIRS() {
  const response = await apiIRS.request('get', '/user');
  return response?.data;
}
